import {Alert, DrawerProps} from '@mantine/core';
import {useParams} from 'react-router-dom';
import {PlatformDrawer, PlatformLoader} from '@flexinet/ui-components';
import {FormDrawer} from './FormDrawer';
import {useUser} from '../hooks/useUser';
import config from '../config';

export const EditFormDrawer = (props: DrawerProps) => {
    const {id: userId} = useParams();

    if (typeof userId === 'undefined') {
        throw new Error('userId is required parameter');
    }

    const {record, loading, isError, updateRecord} = useUser(userId);

    // Never render nothing: the console's copy returned null when the person was
    // not in the cached list, so clicking Edit appeared to do nothing at all.
    if (!record) {
        return (
            <PlatformDrawer opened={props.opened} onClose={props.onClose} title={`Edit ${config.titles.singular}`}>
                {loading
                    ? <PlatformLoader message='Loading user...'/>
                    : <Alert color='red' title='Could not load this user'>
                        {isError ? 'users-api did not return this person. Close and try again.' : 'This person was not found.'}
                    </Alert>}
            </PlatformDrawer>
        );
    }

    return <FormDrawer record={record} handleSubmit={updateRecord} {...props}/>;
};
